import { render, staticRenderFns } from "./VCardBloco.vue?vue&type=template&id=689fc5c9"
import script from "./VCardBloco.vue?vue&type=script&lang=js"
export * from "./VCardBloco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports